import React from 'react'
import styles from './Skeleton.module.css'
import { isIOS } from '../../utils/config'
import { Avatar } from '../avatar/Avatar'

export const Skeleton: React.FC = () => {
  let btnCls = ''
  if (!isIOS) {
    btnCls = 'skeleton-bottom-android'
  }

  return (
    <div className={styles.skeletonContainer}>
      <div className={styles.skeletonTop}>
        <Avatar className={styles.avatar} />
      </div>
      <div className={styles.skeletonMiddle} />
      <div className={[styles.skeletonBottom, styles[`${btnCls}`]].join(' ')} />
    </div>
  )
};

